import {
  collection,
  addDoc,
  getDoc,
  doc,
  serverTimestamp,
  arrayUnion,
  arrayRemove,
  updateDoc,
  setDoc,
  getDocs,
  deleteDoc,
  query,
  where,
  or,
} from "firebase/firestore";
import { db, auth } from "../FireStore";
import { updateUser } from "./user";

export async function createGlobalOption(optionData, collectionName) {
  // Create a new document reference with an auto-generated ID
  const optionRef = doc(collection(db, collectionName));

  // Set the document data, including the generated ID
  await setDoc(optionRef, {
    ...optionData,
    isGlobal: true,
    id: optionRef.id, // Include the auto-generated ID in the document data
    createdAt: serverTimestamp(),
  });

  // Return a message with the generated document ID
  return optionRef.id;
}

export async function createCompanyOption(optionData, collectionName) {
  if (!optionData.companyId) {
    console.warn("Company ID is required to create company specific option.");
    return;
  }

  // Create a new document reference with an auto-generated ID
  const optionRef = doc(collection(db, collectionName));

  // Set the document data, including the generated ID
  await setDoc(optionRef, {
    ...optionData,
    isGlobal: false,
    id: optionRef.id, // Include the auto-generated ID in the document data
    createdAt: serverTimestamp(),
  });

  // Return a message with the generated document ID
  return optionRef.id;
}

// update document in collection
export async function updateGlobalOption(optionData, collectionName) {
  const optionRef = doc(db, collectionName, optionData.id);

  await updateDoc(optionRef, {
    ...optionData,
    updatedAt: serverTimestamp(),
  });

  return `Global Option with ID ${optionData.id} updated successfully.`;
}

// forever delete item from collection
export async function deleteGlobalOption(optionId, collectionName) {
  const optionRef = doc(db, collectionName, optionId);
  await deleteDoc(optionRef);
  return `Global Option with ID ${optionId} deleted successfully.`;
}

// get all data from a specific collection
export async function getAllCollection(name, companyId) {
  if (!companyId) {
    console.warn("Company ID is required to get company specific data.");
    return [];
  }

  // const typesCollectionRef = collection(db, name);

  // const typesQuery = query(collection(db, name), where("isGlobal", "==", true));
  // const typesQuery = query(collection(db, name));

  const typesQuery = query(
    collection(db, name),
    or(where("isGlobal", "==", true), where("companyId", "==", companyId))
    // or(where("isGlobal", "==", true), where("isGlobal", "==", false))
  );

  const typesSnapshot = await getDocs(typesQuery);

  if (typesSnapshot.empty) {
    console.log(`No ${name} found in the collection.`);
    return [];
  }

  const typesData = typesSnapshot.docs.map((doc) => {
    return { id: doc.id, ...doc.data() };
  });

  return typesData;
}

// get company specific data from a specific collection
export async function getCompanyCollection(name, companyId) {
  if (!companyId) {
    console.warn("Company ID is required to get company specific data.");
    return [];
  }

  // const typesQuery = query(
  //   collection(db, name),
  //   where("isGlobal", "==", false) //,where("companyId", "==", companyId)
  // );

  const typesQuery = query(
    collection(db, name),
    or(where("isGlobal", "==", true), where("companyId", "==", companyId))
  );

  const typesSnapshot = await getDocs(typesQuery);

  if (typesSnapshot.empty) {
    console.log(`No ${name} found in the collection.`);
    return [];
  }

  return typesSnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
}
